import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getSubscriptionContractedPowersChoices } from '@/api/subscription.api';

import type { SubscriptionContractedPowers } from '@/types/subscription.type';

export default defineStore('electricity-supplier', () => {
  const isGetSubscriptionContractedPowersChoicesInProgress = ref(false);
  const findSubscriptionContractedPowersChoices =
    async (): Promise<SubscriptionContractedPowers> => {
      isGetSubscriptionContractedPowersChoicesInProgress.value = true;
      try {
        return await getSubscriptionContractedPowersChoices();
      } finally {
        isGetSubscriptionContractedPowersChoicesInProgress.value = false;
      }
    };

  return {
    isGetSubscriptionContractedPowersChoicesInProgress,
    findSubscriptionContractedPowersChoices,
  };
});
